import Logger from 'services/Logger';
import amwellClient from 'lib/amwell/client';
import * as amwellTypes from 'lib/amwell/client/types';
import { AnyAction } from '@reduxjs/toolkit';
import { oc } from 'ts-optchain';
import Config from 'react-native-config';
import AwsdkError from './amwell/client/errors/AwsdkError';

interface AmwellRequestConfig<T extends keyof amwellTypes.Dispatch> {
  resourceName: T;
  reduxSourceAction: AnyAction;
  data: amwellTypes.ExecuteData<T>;
}

async function request<T extends keyof amwellTypes.Dispatch>({
  resourceName,
  data
}: AmwellRequestConfig<T>) {
  // Using a basic promise to leverage the reject within the promise for setTimeout, and clearTimeout
  return new Promise((resolve, reject) => {
    // Start Timer
    const timer = setTimeout(
      () => {
        reject(new AwsdkError('request', 'Request Timeout'));
      },
      Config.AMWELL_TIMEOUT ? parseInt(Config.AMWELL_TIMEOUT, 10) : 60000
    );

    // Send Call
    amwellClient
      .execute(resourceName, data)
      .then(res => {
        // Clear The timer
        clearTimeout(timer);

        const errors = oc(res).errors([]);
        const success = oc(res).success(true);

        if (errors.length) {
          const err = new Error(errors);
          Logger.log('Amwell Request Fail', err);
          return reject(err);
        }

        if (success === false) {
          const err = new Error('Response Failed');
          Logger.log('Amwell Request Fail', err);
          return reject(err);
        }

        return resolve(res);
      })
      .catch((err: Error) => {
        clearTimeout(timer);
        reject(err);
      });
  });
}

export default {
  create: () => ({
    request
  }),
  options: () => ({
    interceptors: null
  })
};
